/*
 * DJM-03: keyboard focus management for the disclosure main navigation.
 * The theme opens a top-level submenu by adding `.is-open`, but only closes a
 * previously-open menu when another is opened via hover/click. With a keyboard,
 * Tabbing to the next top-level item (or out of the nav) left the previous
 * submenu open. This closes an open top-level submenu when focus moves to a
 * different top-level item or leaves the nav, and on Escape (WCAG 2.4.3).
 * Desktop only (>=768px); the mobile drawer keeps its own behaviour.
 */
(function () {
  function init() {
    var nav = document.querySelector('.main-nav');
    if (!nav) return;
    var mq = window.matchMedia('(min-width: 768px)');

    function openTopMenus() {
      return Array.prototype.slice
        .call(nav.querySelectorAll('details.is-open'))
        .filter(function (d) {
          var s = d.querySelector(':scope > summary');
          return s && s.classList.contains('js-nav-hover');
        });
    }

    function closeMenu(d) {
      d.classList.remove('is-open');
    }

    function syncOverlay() {
      if (!nav.querySelector('details.is-open')) {
        var ov = document.querySelector('.js-overlay.is-visible');
        if (ov) ov.classList.remove('is-visible');
      }
    }

    document.addEventListener('focusin', function (e) {
      if (!mq.matches) return; // desktop only
      var insideNav = nav.contains(e.target);
      openTopMenus().forEach(function (d) {
        if (!insideNav || !d.contains(e.target)) closeMenu(d);
      });
      syncOverlay();
    });

    nav.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      if (!mq.matches) return;
      var open = e.target.closest('details.is-open');
      if (open && open.querySelector(':scope > summary.js-nav-hover')) {
        var summary = open.querySelector(':scope > summary');
        closeMenu(open);
        syncOverlay();
        if (summary) summary.focus();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
